import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  root: {
    minWidth: "100%",
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
  },
}));

export default useStyles;
